import React from "react";

// Render an ISO-ish datetime as "YYYY-MM-DD HH:mm" (24h). Returns "—" when empty.
const fmtDateTime = (v) => {
  if (!v) return "—";
  const s = String(v);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;          // date-only → keep as-is
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/**
 * Freight Summary strip — a consistent freight detail block
 * shared by the BOL, Rate Confirmation and Invoice PDF views.
 */
export default function FreightSummary({ doc = {}, title = "FREIGHT DETAILS" }) {
  const {
    job_number,
    po_number,
    reference,
    commodity,
    pieces,
    pieces_unit,
    weight,
    equipment,
    service_type,
    pickup_date,
    appointment_date,
    delivery_date,
  } = doc;

  const piecesStr =
    pieces || pieces === 0
      ? `${pieces} ${(pieces_unit || "").trim() || "pcs"}`
      : "—";
  const weightStr = weight ? `${Number(weight).toLocaleString()} lb` : "—";
  const service = [service_type, equipment].filter(Boolean).join(" / ") || "—";

  const Cell = ({ label, value, mono = true, testId }) => (
    <div>
      <div className="mono-label">{label}</div>
      <div className={`mt-1 ${mono ? "font-mono" : ""}`} data-testid={testId}>
        {value || "—"}
      </div>
    </div>
  );

  return (
    <div className="mt-6 border border-zinc-200 bg-zinc-50" data-testid="freight-summary">
      <div className="bg-zinc-950 text-white px-3 py-1.5 mono-label !text-zinc-100">
        {title}
      </div>
      <div className="p-4 grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
        <Cell label="Job #"        value={job_number}  testId="fs-job"       />
        <Cell label="PO #"         value={po_number}   testId="fs-po"        />
        <Cell label="Reference #"  value={reference}   testId="fs-ref"       />
        <Cell label="Service"      value={service}     testId="fs-service"   />

        <Cell label="Pickup date/time"    value={fmtDateTime(pickup_date)}      testId="fs-pickup-dt"   />
        <Cell label="Appointment"         value={fmtDateTime(appointment_date)} testId="fs-appt"        />
        <Cell label="Delivery date/time"  value={fmtDateTime(delivery_date)}    testId="fs-delivery-dt" />
        <Cell label="Equipment"           value={equipment}                     mono={false} testId="fs-equipment" />

        <Cell label="Commodity"   value={commodity}   mono={false} testId="fs-commodity" />
        <Cell label="Pieces"      value={piecesStr}   testId="fs-pieces"    />
        <Cell label="Weight"      value={weightStr}   testId="fs-weight"    />
      </div>
    </div>
  );
}
